import React, { useEffect, useState } from 'react';
import './FeedbackPopup.css';
import feedbackImage from '../../assets/images/feedbackpopup.jpg';

const FeedbackPopup = () => {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    const lastShownDate = localStorage.getItem('feedbackPopupDate');
    const today = new Date().toDateString(); // e.g. "Fri May 16 2025"

    if (lastShownDate !== today) {
      const timer = setTimeout(() => {
        setShowPopup(true);
        localStorage.setItem('feedbackPopupDate', today);
      }, 90000); // show after 90 seconds

      return () => clearTimeout(timer);
    }
  }, []);

  const handleClose = () => {
    setShowPopup(false);
  };

  const handleFeedbackClick = () => {
    window.open('/feedback', '_blank');
  };

  return (
    <>
      {showPopup && (
        <div className="feedback-overlay">
          <div className="feedback-popup-card slide-in">
            <button className="close-btn" onClick={handleClose}>×</button>
            <img
              src={feedbackImage}
              alt="Feedback Illustration"
              className="feedback-image"
            />
            <p className="feedback-text">
              We'd love your feedback! Help us improve by sharing your thoughts.
            </p>
            <button className="feedback-btn" onClick={handleFeedbackClick}>
              Give Feedback
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default FeedbackPopup;
